import { useEffect, useState } from "react";
import api from "@/lib/api";
import { BrandLogo } from "@/components/brand/BrandLogo";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
let ctxPromise = null;
const loadCtx = () => (ctxPromise ||= api.get("/establishments/context").then((r) => r.data).catch(() => null));

/** Header brand for the SELECTED establishment. SUNTRONIX / All Establishments → locked SUNTRONIX logo; other entities → their own
 *  approved uploaded logo, or the plain company name when none is configured / the file fails to load (never the SUNTRONIX logo). */
export function EntityBrandLogo({ className = "w-[124px] md:w-[166px]" }) {
  const [ctx, setCtx] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => { loadCtx().then(setCtx); }, []);
  const sel = window.localStorage.getItem("st.establishment") || ctx?.selected;
  const est = ctx?.establishments?.find((e) => e.id === sel);
  if (!ctx || !est || sel === "ALL" || est.is_primary || est.id === "est_suntronix") {
    return <BrandLogo className={className} testid="app-header-suntronix-logo" />;
  }
  const name = (est.display_name || est.legal_name || est.short_name || "").toUpperCase();
  if (est.logo_url && !failed) {
    return <img src={`${BACKEND}${est.logo_url}`} alt={name} onError={() => setFailed(true)} draggable={false}
      className="h-9 md:h-11 w-auto max-w-[180px] object-contain" data-testid="app-header-entity-logo" />;
  }
  return (
    <span className="font-display text-[18px] md:text-[22px] font-black tracking-[0.06em] leading-none" style={{ color: est.branding?.primary_color || "#0f172a" }}
      title={est.logo_url ? "Logo file could not be loaded" : "No approved logo configured for this establishment"} data-testid="app-header-entity-name">{name}</span>
  );
}
